import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { withRouter } from 'react-router-dom';
import Page from '../../components/Page/Page';
import { SearchBar } from '../../components';
import { NetworkContext } from '../../context/NetworkContext';
import { SnackBarContext } from '../../context/SnackbarContext';
import { Header, Results } from './components';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: '100%',
    padding: theme.spacing(3),
  },
  results: {
    marginTop: theme.spacing(3),
  },
}));

export const ManageFeedback = withRouter(props => {
  const classes = useStyles();
  const [orders, setOrders] = useState([]);
  const [searchtext, setSearchtext] = useState('');
  const { sendNetworkRequest } = React.useContext(NetworkContext);
  const snackbarCtx = React.useContext(SnackBarContext);

  async function fetchFeedbacks(nextSearch = searchtext) {
    const result = await sendNetworkRequest('/admin/getfeedbacks', {}, {
      searchtext: nextSearch || '',
    }, false);
    setOrders(result?.feedbacks || []);
  }

  function onSearch(value) {
    setSearchtext(value);
    fetchFeedbacks(value);
  }

  async function updateFeedbackStatus(row, status) {
    const result = await sendNetworkRequest('/admin/updatefeedbackstatus', {}, {
      id: row.id,
      status,
    }, false);
    snackbarCtx.setSnack({
      ...snackbarCtx,
      open: true,
      type: result.status || 'error',
      msg: result.message || 'Unable to update status',
      vertical: 'top',
    });
    if (result.status === 'success') {
      fetchFeedbacks();
    }
  }

  useEffect(() => {
    fetchFeedbacks();
  }, []);

  return (
    <Page className={classes.root} title="Manage Feedback">
      <Header />
      <SearchBar onSearch={onSearch} />
      <Results
        className={classes.results}
        orders={orders}
        onUpdatestattus={updateFeedbackStatus}
      />
    </Page>
  );
});

export default ManageFeedback;
